import imageCompression from 'browser-image-compression';

const ONE_MEGABYTE = 1024 * 1024;

const profiles = {
    person: {
        maxSizeMB: 700 / 1024,
        maxWidthOrHeight: 1600,
        initialQuality: 0.86,
    },
    book: {
        maxSizeMB: 1200 / 1024,
        maxWidthOrHeight: 2000,
        initialQuality: 0.9,
    },
};

function createCompressedFile(source, compressed) {
    const baseName = (source.name || 'upload').replace(/\.[^.]+$/, '');
    return new File([compressed], `${baseName}.jpg`, {
        type: 'image/jpeg',
        lastModified: source.lastModified || Date.now(),
    });
}

export function formatFileSize(size) {
    if (!size) {
        return '0KB';
    }
    if (size < ONE_MEGABYTE) {
        return `${Math.max(1, Math.round(size / 1024))}KB`;
    }
    return `${(size / ONE_MEGABYTE).toFixed(1)}MB`;
}

export async function compressUploadImage(file, type, onProgress) {
    const profile = profiles[type];
    if (!profile || !file || !file.type || !file.type.startsWith('image/')) {
        return file;
    }

    let compressed;
    try {
        compressed = await imageCompression(file, {
            ...profile,
            fileType: 'image/jpeg',
            preserveExif: false,
            useWebWorker: true,
            onProgress,
        });
    } catch (error) {
        return file;
    }

    if (!compressed || compressed.size >= file.size) {
        return file;
    }

    return createCompressedFile(file, compressed);
}
